import { render, staticRenderFns } from "./ModalShareNew.vue?vue&type=template&id=5b3e2e5a&scoped=true"
import script from "./ModalShareNew.vue?vue&type=script&lang=js"
export * from "./ModalShareNew.vue?vue&type=script&lang=js"
import style0 from "./ModalShareNew.vue?vue&type=style&index=0&id=5b3e2e5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e2e5a",
  null
  
)

export default component.exports